import firebase from 'firebase/app';
import 'firebase/auth';

const firebaseConfig = {
    apiKey: "AIzaSyDj-7HU3DSGVBI0GE9VX7ivnVKwvSOs3Qc",
    authDomain: "clone-53bb8.firebaseapp.com",
    projectId: "clone-53bb8",
    storageBucket: "clone-53bb8.appspot.com",
    messagingSenderId: "11203757605",
    appId: "1:11203757605:web:74a0f14c2686a8d02f61cc"
  };

  firebase.initializeApp(firebaseConfig);

  export default firebase.auth();